import gql from 'graphql-tag'
import { main } from './fragments'

export default gql`
mutation updateSalesGroup($id: ID!, $fields: SalesGroupFields) {
	cashAssist {
		updateSalesGroup(id: $id, fields: $fields) {
			...salesGroupMain
		}
	}
}
${main}`
